import axios from 'axios'
import account from './modules/account.module/account.module'
import admin from './modules/admin.module/admin.module'
import forward from './modules/forward.module/forward.module'
import myCrypto from './libs/MyCrypto.lib'

export default {
  state: {
    // apiPath: '/api'
    apiPath:
      process.env.NODE_ENV === 'development'
        ? `http://${window.location.hostname}/p221001/public/api/`
        : 'api/'
    // apiPath:
    //   process.env.NODE_ENV === 'development'
    //     ? 'http://localhost/p221001/public/api/'
    //     : 'api/'
  },
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    sendRequestWithOtherUrlENC({ state }, obj) {
      if (!obj.params)
        return new Promise.reject({
          code: '0x0000',
          message: 'Params could not be empyt!'
        })

      const data = {}
      obj.params.forEach(e => {
        if (e.key) data[e.key] = e.value
      })

      const cryptodata = myCrypto.Crypto(JSON.stringify(data))
      const formData = new FormData()
      formData.append('data', cryptodata)

      if (obj.files) {
        obj.files.forEach(e => {
          if (e.key) formData.append(e.key, e.value)
        })
      }

      return axios.post(obj.url, formData)
    },
    // eslint-disable-next-line no-unused-vars
    sendRequestWithOtherUrl({ state }, obj) {
      if (!obj.params)
        return new Promise.reject({
          code: '0x0000',
          message: 'Params could not be empyt!'
        })

      const formData = new FormData()
      obj.params.forEach(e => {
        formData.append(e.key, e.value)
      })

      // const data = {}
      // obj.params.forEach(e => {
      //   if (e.key) data[e.key] = e.value
      // })

      // const cryptodata = myCrypto.Crypto(JSON.stringify(data))
      // const formData = new FormData()
      // formData.append('data', cryptodata)

      if (obj.files) {
        obj.files.forEach(e => {
          if (e.key) formData.append(e.key, e.value)
        })
      }

      return axios.post(obj.url, formData)
    },
    // eslint-disable-next-line no-unused-vars
    sendRequest({ state }, obj) {
      if (!obj.params)
        return new Promise.reject({
          code: '0x0000',
          message: 'Params could not be empyt!'
        })

      const data = {}
      obj.params.forEach(e => {
        if (e.key) data[e.key] = e.value
      })

      const cryptodata = myCrypto.Crypto(JSON.stringify(data))
      const formData = new FormData()
      formData.append('data', cryptodata)

      if (obj.files) {
        obj.files.forEach(e => {
          if (e.key) formData.append(e.key, e.value)
        })
      }
      // axios.defaults.baseURL = '/api'
      // return axios.post('/proxy', formData)
      return axios.post(state.apiPath, formData)
      // return axios.post(state.apiPath, {
      //   proxy: {
      //     host: '192.168.1.111',
      //     port: 80
      //   }
      // })
      // #region
      // return axios({
      //   method: 'POST',
      //   url: state.apiPath,
      //   headers: { 'content-type': 'application/x-www-form-urlencoded' },
      //   data: formData
      // })

      // return new Promise((resolve, reject) => {
      //   axios({
      //     method: 'POST',
      //     url: state.apiPath,
      //     data: formData
      //   })
      //     .then(res => {
      //       resolve(res)
      //     })
      //     .catch(err => {
      //       reject(err)
      //     })
      // })
      // #endregion
    }
  },
  modules: {
    account,
    admin,
    forward
  }
}
